module.exports = __webpack_public_path__ + "static/media/car.44c0c775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/car.jpg
// module id = 185
// module chunks = 0